package one.healthium.ui.common.event_producer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue

@Composable
fun <T> EventEffect(evensProducer: EventProducer<T>, block: suspend (T) -> Unit) {
    val event by evensProducer.events.collectAsState(null)

    LaunchedEffect(event) {
        val _event = event
        if (_event != null) {
            block(_event)
        }
        event?.let { evensProducer.consume(it) }
    }
}